// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .mapWrapper {
  position: relative;
}
:host .mapWrapper .mobileTeamLabel {
  display: none;
}
@media (max-width: 768px) {
  :host .mapWrapper .mobileTeamLabel {
    z-index: 400;
    display: block;
    position: absolute;
    top: 50%;
  }
  :host .mapWrapper .mobileTeamLabel.home {
    transform: translateY(-76px);
    left: 0;
  }
  :host .mapWrapper .mobileTeamLabel.home label {
    transform-origin: top left;
    margin-left: 6px;
  }
  :host .mapWrapper .mobileTeamLabel.home .icon {
    margin-left: 4px;
  }
  :host .mapWrapper .mobileTeamLabel.visitor {
    transform: translateY(0);
    right: 0;
  }
  :host .mapWrapper .mobileTeamLabel.visitor label {
    transform-origin: top right;
    margin-right: 22px;
    padding-right: 65px;
  }
  :host .mapWrapper .mobileTeamLabel.visitor .icon {
    margin-left: auto;
    margin-right: 4px;
  }
  :host .mapWrapper .mobileTeamLabel label {
    display: block;
    transform: rotate(-90deg);
    font-size: 12px;
    line-height: 16px;
    color: #383D4C;
    font-weight: 500;
    font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  }
  :host .mapWrapper .mobileTeamLabel .icon {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: #FFF;
    border: 2px solid #AEB1B9;
    overflow: hidden;
  }
  :host .mapWrapper .mobileTeamLabel .icon::ng-deep svg {
    width: 38px;
    height: 38px;
  }
  :host .mapWrapper .mobileTeamLabel .icon::ng-deep svg #Fill-3, :host .mapWrapper .mobileTeamLabel .icon::ng-deep svg #Fill-5 {
    fill: #000;
  }
}
:host .teams {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
}
@media (max-width: 768px) {
  :host .teams {
    display: none;
  }
}
:host .teams app-players-list {
  display: flex;
  flex: 0 0 45%;
}
:host .teams app-players-list.left {
  justify-content: flex-start;
}
:host .teams app-players-list.right {
  justify-content: flex-end;
}
:host .teams .wrapper-clearPlayerSelected {
  display: flex;
  flex: 0 0 10%;
  justify-content: center;
}
:host .teams .wrapper-clearPlayerSelected .clearPlayerSelected {
  display: block;
  height: 36px;
  width: 36px;
  border-radius: 50%;
  background-color: #FFF;
  background-image: url("/assets/img/icons/positive-dark/close.svg");
  background-size: 24px;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: opacity 0.1s ease-out;
}
:host .teams .wrapper-clearPlayerSelected .clearPlayerSelected.shown {
  opacity: 1;
  cursor: pointer;
}
:host .teams .wrapper-clearPlayerSelected .name {
  text-transform: uppercase;
  font-size: 10px;
  display: block;
  font-weight: 700;
  bottom: -20px;
  position: absolute;
}
:host .mapFooter {
  padding-bottom: 12px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  position: relative;
}
:host .mapFooter app-map-controls {
  flex: 1 1 auto;
}
:host .mapFooter app-map-controls ::ng-deep app-selector ::ng-deep .button {
  white-space: nowrap;
}
:host .mapFooter .legendWrapper {
  display: flex;
}
:host .mapFooter .legendWrapper > * + * {
  margin-left: 24px;
}
:host .mapFooter .small-legend app-legend ::ng-deep li {
  width: auto;
}
:host .mapFooter .legendToggle {
  display: none;
}
@media (max-width: 768px) {
  :host .mapFooter .legendToggle {
    display: block;
    border: none;
    flex: 1;
    max-width: 130px;
    background: #FFF;
    color: #3E31FA;
    text-transform: uppercase;
    font-size: 10px;
    line-height: 32px;
    text-align: center;
    padding-right: 10px;
    white-space: nowrap;
    font-weight: 700;
    font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  }
  :host .mapFooter .legendToggle:before {
    content: "";
    display: inline-block;
    height: 12px;
    width: 12px;
    background-image: url("/assets/img/icons/color/help.svg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    vertical-align: middle;
    margin-right: 4px;
  }
}
@media (max-width: 768px) {
  :host .mapFooter {
    padding: 0 24px;
  }
  :host .mapFooter .legendWrapper {
    display: none;
  }
  :host .mapFooter .legendWrapper.open {
    display: block;
    position: absolute;
    bottom: 55px;
    right: 0;
    background: #FFF;
    z-index: 400;
    padding: 12px;
    margin-right: 12px;
  }
  :host .mapFooter .legendWrapper.open:after {
    content: "";
    display: block;
    position: absolute;
    left: 50%;
    bottom: 0;
    z-index: 401;
    transform: translate(-50%, 100%);
    border-style: solid;
    border-width: 6px 6px 0 6px;
    border-color: #FFF transparent transparent;
  }
  :host .mapFooter .legendWrapper.open app-legend[type=enum] ::ng-deep li img {
    border-radius: 50%;
    border: 1px solid #AEB1B9;
  }
}

@-moz-document url-prefix() {
  .leaflet-marker-icon.marker.stat.mini .points {
    margin-bottom: 1px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/map/map/map.component.scss","webpack://./src/theme.scss"],"names":[],"mappings":"AAGE;EACE,kBAAA;AAFJ;AAGI;EACE,aAAA;AADN;AAEM;EAFF;IAGI,YAAA;IACA,cAAA;IACA,kBAAA;IACA,QAAA;EACN;EAAM;IACE,4BAAA;IACA,OAAA;EAER;EADQ;IACE,0BAAA;IACA,gBAAA;EAGV;EADQ;IACE,gBAAA;EAGV;EAAM;IACE,wBAAA;IACA,QAAA;EAER;EADQ;IACE,2BAAA;IACA,kBAAA;IACA,mBAAA;EAGV;EADQ;IACE,iBAAA;IACA,iBAAA;EAGV;EAAM;IACE,cAAA;IACA,yBAAA;IACA,eAAA;IACA,iBAAA;IACA,cChCC;IAoDP,gBAAA;IAUA,+DAAA;ED1BF;EADM;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,gBC9BG;ID+BH,yBAAA;IACA,gBAAA;EAGR;EADU;IACE,WAAA;IACA,YAAA;EAGZ;EAFY;IACE,UAAA;EAId;AACF;AAIE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,kBAAA;AAFJ;AAGI;EALF;IAMI,aAAA;EAAJ;AACF;AAEI;EACE,aAAA;EACA,aAAA;AAAN;AAEM;EACE,2BAAA;AAAR;AAGM;EACE,yBAAA;AADR;AAKI;EACE,aAAA;EACA,aAAA;EACA,uBAAA;AAHN;AAKM;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBC/EK;EDgFL,kEAAA;EACA,qBAAA;EACA,2BAAA;EACA,4BAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,iCAAA;AAHR;AAKQ;EACE,UAAA;EACA,eAAA;AAHV;AAOM;EACE,yBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AALR;AAUE;EACE,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;AARJ;AAUI;EACE,cAAA;AARN;AAUM;EACE,mBAAA;AARR;AAYI;EACE,aAAA;AAVN;AAWM;EACE,iBAAA;AATR;AAcM;EACE,WAAA;AAZR;AAgBI;EACE,aAAA;AAdN;AAeM;EAFF;IAGI,cAAA;IACA,YAAA;IACA,OAAA;IACA,gBAAA;IACA,gBC/IK;IDgJL,cClKO;IDmKP,yBAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;IACA,mBAAA;IACA,mBAAA;ICzGJ,gBAAA;IAQA,+DAAA;EDuFF;EAYM;IC9FN,WAAA;IACA,qBAAA;IACA,YD6FoE;IC5FpE,WD4F0E;IC3F1E,yDAAA;IACA,2BAAA;IACA,4BAAA;IACA,wBAAA;IDyFQ,sBAAA;IACA,iBAAA;EAHR;AACF;AAOI;EApDF;IAqDI,eAAA;EAJJ;EAKI;IACE,aAAA;EAHN;EAIM;IACE,cAAA;IACA,kBAAA;IACA,YAAA;IACA,QAAA;IACA,gBCzKG;ID0KH,YAAA;IACA,aAAA;IACA,kBAAA;EAFR;EAGQ;IACE,WAAA;IACA,cAAA;IACA,kBAAA;IACA,SAAA;IACA,SAAA;IACA,YAAA;IACA,gCAAA;IACA,mBAAA;IACA,2BAAA;IACA,0CAAA;EADV;EAIU;IACE,kBAAA;IACA,yBAAA;EAFZ;AACF;;AASA;EACE;IACE,kBAAA;EANF;AACF","sourcesContent":["@import 'theme';\n\n:host {\n  .mapWrapper {\n    position: relative;\n    .mobileTeamLabel {\n      display: none;\n      @media (max-width: $mobileBreakpoint) {\n        z-index: 400;\n        display: block;\n        position: absolute;\n        top: 50%;\n        &.home {\n          transform: translateY(-76px);\n          left: 0;\n          label {\n            transform-origin: top left;\n            margin-left: 6px;\n          }\n          .icon {\n            margin-left: 4px;\n          }\n        }\n        &.visitor {\n          transform: translateY(0);\n          right: 0;\n          label {\n            transform-origin: top right;\n            margin-right: 22px;\n            padding-right: 65px;\n          }\n          .icon {\n            margin-left: auto;\n            margin-right: 4px;\n          }\n        }\n        label {\n          display: block;\n          transform: rotate(-90deg);\n          font-size: 12px;\n          line-height: 16px;\n          color: $colorN80;\n          @include font(medium);\n        }\n        .icon {\n          width: 38px;\n          height: 38px;\n          border-radius: 50%;\n          background: $colorWhite;\n          border: 2px solid $colorN30;\n          overflow: hidden;\n          &::ng-deep {\n            svg {\n              width: 38px;\n              height: 38px;\n              #Fill-3, #Fill-5 {\n                fill: #000;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .teams {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    position: relative;\n    @media(max-width: $mobileBreakpoint) {\n      display: none;\n    }\n\n    app-players-list {\n      display: flex;\n      flex: 0 0 45%;\n\n      &.left {\n        justify-content:flex-start;\n      }\n\n      &.right {\n        justify-content:flex-end;\n      }\n    }\n\n    .wrapper-clearPlayerSelected {\n      display: flex;\n      flex: 0 0 10%;\n      justify-content: center;\n\n      .clearPlayerSelected {\n        display: block;\n        height: 36px;\n        width: 36px;\n        border-radius: 50%;\n        background-color: $colorWhite;\n        background-image: url('/assets/img/icons/positive-dark/close.svg');\n        background-size: 24px;\n        background-position: center;\n        background-repeat: no-repeat;\n        opacity: 0;\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        transform: translate(-50%, -50%);\n        transition: opacity $animationTimeBlink $animationFuncDefault;\n\n        &.shown {\n          opacity: 1;\n          cursor: pointer;\n        }\n      }\n\n      .name {\n        text-transform: uppercase;\n        font-size: 10px;\n        display: block;\n        font-weight: 700;\n        bottom: -20px;\n        position: absolute;\n      }\n    }\n  }\n\n  .mapFooter {\n    padding-bottom: 12px;\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-end;\n    position: relative;\n\n    app-map-controls {\n      flex: 1 1 auto;\n\n      ::ng-deep app-selector ::ng-deep .button {\n        white-space: nowrap;\n      }\n    }\n\n    .legendWrapper {\n      display: flex;\n      & > * + * {\n        margin-left: 24px;\n      }\n    }\n\n    .small-legend app-legend ::ng-deep {\n      li {\n        width: auto;\n      }\n    }\n\n    .legendToggle {\n      display: none;\n      @media (max-width: $mobileBreakpoint) {\n        display: block;\n        border: none;\n        flex: 1;\n        max-width: 130px;\n        background: $colorWhite;\n        color: $colorPrimary;\n        text-transform: uppercase;\n        font-size: 10px;\n        line-height: 32px;\n        text-align: center;\n        padding-right: 10px;\n        white-space: nowrap;\n        @include font(bold);\n        &:before {\n          @include pseudoElemIcon('/assets/img/icons/color/help.svg', 12px, 12px);\n          vertical-align: middle;\n          margin-right: 4px;\n        }\n      }\n    }\n\n    @media (max-width: $mobileBreakpoint) {\n      padding: 0 24px;\n      .legendWrapper {\n        display: none;\n        &.open {\n          display: block;\n          position: absolute;\n          bottom: 55px;\n          right: 0;\n          background: $colorWhite;\n          z-index: 400;\n          padding: 12px;\n          margin-right: 12px;\n          &:after {\n            content: '';\n            display: block;\n            position: absolute;\n            left: 50%;\n            bottom: 0;\n            z-index: 401;\n            transform: translate(-50%, 100%);\n            border-style: solid;\n            border-width: 6px 6px 0 6px;\n            border-color: $colorWhite transparent transparent;\n          }\n          app-legend[type=enum] ::ng-deep {\n            li img {\n              border-radius: 50%;\n              border: 1px solid $colorN30;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n@-moz-document url-prefix() {\n  .leaflet-marker-icon.marker.stat.mini .points {\n    margin-bottom: 1px;\n  }\n}\n","$colorPrimary: #3E31FA;\n$colorPrimaryBg: #EEF2FD;\n$colorAccent: #1785FB;\n$colorSecondary: #C8B17B;\n\n$colorAdsBG: #0D0D0D;\n$colorBlack: #000;\n$colorN100: #1A1E29;\n$colorN90: #292D3A;\n$colorN80: #383D4C;\n$colorN70: #4B505F;\n$colorN60: #626775;\n$colorN50: #787D8B;\n$colorN40: #9397A2;\n$colorN30: #AEB1B9;\n$colorN20: #C9CBD1;\n$colorN10: #E4E5E8;\n$colorN05: #F2F2F4;\n$colorWhite: #FFF;\n\n$colorBestPlayer: #F2B701;\n$colorDisabled: $colorN30;\n\n$gridRampComp1: #FFFFFF;\n$gridRampComp2: #FFFFCC;\n$gridRampComp3: #A1DAB4;\n$gridRampComp4: #41B6C4;\n$gridRampComp5: #2C7FB8;\n$gridRampComp6: #253494;\n\n$colorGood: #A2D98C;\n$colorBad: #E73F74;\n$colorLive: #3D923D;\n$colorLiveTooltip: #A2D98C;\n\n$colorNotFound: #DC0032;\n$colorBackgroundTooltip: #0F2145;\n\n$colorGreyPlacehold: #8C95A6;\n$colorGreyTitle: #0F2145;\n$colorGreyLabel: #5E6A83;\n$colorGreyDark: #29395A;\n$colorGreyOffWhite: #FBFDFF;\n$colorGreyOffBlack: #14142B;\n$animationTimeSlow: 2s;\n$animationTimeNormal: 1s;\n$animationTimeFast: .5s;\n$animationTimeBlink: .1s;\n$animationFuncDefault: ease-out;\n$animationFuncAlt: linear;\n\n$mobileBreakpoint: 768px;\n\n@mixin font($weight: normal, $condensed: false) {\n  @if $weight == extra-light {\n    font-weight: 200;\n  } @else if $weight == light {\n    font-weight: 300;\n  } @else if $weight == normal {\n    font-weight: 400;\n  } @else if $weight == medium {\n    font-weight: 500;\n  } @else if $weight == bold {\n    font-weight: 700;\n  } @else if $weight == black {\n    font-weight: 900;\n  }\n\n  @if $condensed == condensed {\n    font-family: 'RM Neue';\n  } @else {\n    font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\n  }\n}\n\n@mixin pseudoElemIcon($file, $height, $width) {\n  content: '';\n  display: inline-block;\n  height: $height;\n  width: $width;\n  background-image: url($file);\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n@mixin noselect() {\n  -webkit-touch-callout: none;\n    -webkit-user-select: none;\n     -khtml-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n@mixin button($file: null) {\n  border: none;\n  cursor: pointer;\n  display: flex;\n  padding: 12px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  border-radius: 12px;\n  background: linear-gradient(8deg, #3E31FA 19.1%, #8760F6 94.27%);\n  color: $colorGreyOffWhite;\n  @include font(medium);\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n\n  @if $file != null {\n    &::before {\n      @include pseudoElemIcon($file, 16px, 16px);\n    }\n  }\n}\n\n@mixin headingH3() {\n  @include font(bold);\n  font-size: 32px;\n  font-style: normal;\n  letter-spacing: -0.5px;\n  margin-bottom:16px;\n  color: $colorGreyOffBlack;\n  text-align: center;\n}\n@mixin headingH5() {\n  @include font(normal);\n  font-size: 24px;\n  font-style: normal;\n  letter-spacing: -0.5px;\n  margin-bottom:16px;\n  color: $colorGreyDark;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
